import script from "./DirectNavigationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectNavigationCard.vue?vue&type=script&setup=true&lang=js"

import "./DirectNavigationCard.vue?vue&type=style&index=0&id=696cb12c&scoped=true&lang=css"
script.__scopeId = "data-v-696cb12c"

export default script